import { css } from '@emotion/react';
import { type PropsWithChildren } from 'react';
import { useTheme } from '~/_shared/themes/theme.hooks';
import type { Theme } from '~/_shared/themes/theme.model';
import { type ThemeProps } from '~/_shared/types/themeProps';

export const getAppBGColor = (theme: Theme) => theme.backgroundColors.primary;

const appPageStyle = ({ theme }: ThemeProps) => css({
  flex: '1',
  display: 'flex',
  background: getAppBGColor(theme),
  overflow: 'hidden',
  position: 'relative',
});

export const AppPageStylesWrapper = ({ children }: PropsWithChildren) => {
  const theme = useTheme();

  return (
    <div css={appPageStyle({ theme })}>
      {children}
    </div>
  );
};
